import OvalLabel from './OvalLabel'
import OvalButton from './OvalButton'
export {
  OvalLabel,
  OvalButton
}



// WEBPACK FOOTER //
// ./src/app/components/common/ovalLabel/index.js